import React, { Component, useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import {
  APIHandler,
  BackButton,
  PremiumHotel,
  FreeHotel,
  StorageHandler,
} from "C4";
import { baseAppId, storageKeys } from "settings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Select from "react-select";
import i18n from "i18n-react";

import SimpleBarReact from "simplebar-react";
import "simplebar/src/simplebar.css";

import MarkerFree from "assets/images/ab-mapGrey.png";
import ClusterFree from "assets/images/ab-mapClusterGrey.png";
import MarkerPremium from "assets/images/ab-map.png";
import ClusterPremium from "assets/images/ab-mapCluster.png";

let containerStyle = {
  width: "100%",
  height: "calc(100vh - 8rem)",
};
const params = new URLSearchParams(window.location.search);
if (params.get("mobile")) {
  containerStyle = {
    width: "100%",
    height: "100vh",
  };
}

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

export default class DirectoryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 22.465833358327526,
      lat2: 17.73191374463721,
      lon1: -84.44926626370966,
      lon2: -89.95890981839716,
      loading: false,
      query: "",
      width: null,
      mobile: false,
      zoom: 8,
      center: {
        lat: 19.58774,
        lng: -86.968964,
      },
      color: "16638b",
      font: "Source Sans Pro",
      userInfo: "",
      language: "en",
      selectedDestinations: [],
      selectedHotelCategories: [],
      selectedAmenities: [],
      subcategories: {
        destination: [
          "Bacalar",
          "Cancun",
          "Chetumal",
          "Costa mujeres",
          "Cozumel",
          "Holbox",
          "Isla Mujeres",
          "Mahahual",
          "Maya Ka'an",
          "Playa del Carmen",
          "Puerto Morelos",
          "Tulum",
        ],
        hotelcategory: ["3", "4", "5"],
        amenities: [
          "Accessible Rooms",
          "Swimming Pool",
          "Gym/ Fitness Center",
          "Restaurants",
          "Bar/Lounge",
          "Spa",
          "Meeting/ Conference Rooms",
          "Private Beach Access",
          "Golf/Mini-Golf",
        ],
      },
      filterOpen: false,
      logo: null,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDestinationChange = this.handleDestinationChange.bind(this);
    this.handleHotelCategoryChange = this.handleHotelCategoryChange.bind(this);
    this.handleAmenitiesChange = this.handleAmenitiesChange.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.flyToMarker = this.flyToMarker.bind(this);
    this.resetMap = this.resetMap.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.premiumInfo = this.premiumInfo.bind(this);
    this.freeInfo = this.freeInfo.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    let mobile = false;
    if (params.get("mobile") || params.get("header") === "false") {
      mobile = true;
    }
    this.setState({ mobile, width });

    if (width < 800) {
      this.getHotelsList();
    }
    this.getLogo();
    this.setState({
      language: JSON.parse(
        localStorage.getItem("lang")
      ).rawData.langFile.toLowerCase(),
    });
  }

  async getLogo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWhite,
      });
    }
  }

  handleInputChange() {
    this.setState(
      {
        query: this.search.value,
      },
      this.getHotelsList()
    );
  }

  loadProperties(bounds, zoom) {
    this.setState({
      lat1: bounds.getNorthEast().lat(),
      lat2: bounds.getSouthWest().lat(),
      lon1: bounds.getNorthEast().lng(),
      lon2: bounds.getSouthWest().lng(),
      zoom,
    });
    this.getHotelsList();
  }

  getHotelsList() {
    this.setState({ loading: true, freeHotelsList: [] });
    setTimeout(() => {
      const {
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        selectedDestinations,
        selectedHotelCategories,
        selectedAmenities,
      } = this.state;
      console.log("Calling API with filters:", {
        selectedDestinations,
        selectedHotelCategories,
        selectedAmenities,
      });

      APIHandler.getFreeHotelsList(
        baseAppId,
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        selectedDestinations,
        selectedHotelCategories,
        selectedAmenities
      ).then((results) => {
        this.setState({ freeHotelsList: results, loading: false });
      });
    }, 200);

    // APIHandler.getPremiumHotelsList(lat1, lat2, lon1, lon2).then((results) => {
    //   this.setState({ premiumHotelsList: results.items });
    // });
  }

  flyToMarker(lat, lon) {
    this.setState({
      zoom: 20,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  }

  resetMap() {
    this.setState({
      zoom: 11,
      center: {
        lat: 19.58774,
        lng: -86.968964,
      },
    });
  }

  resetFilters() {
    this.setState(
      {
        selectedDestinations: [],
        selectedHotelCategories: [],
        selectedAmenities: [],
      },
      () => {
        this.getHotelsList();
      }
    );
  }

  premiumInfo(userInfoID) {
    document.getElementById("iframe").classList.remove("hide");
    this.setState({
      userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=${baseAppId}`,
    });
  }

  freeInfo(userInfoID) {
    console.log(userInfoID);
    if (this.state.mobile) {
      window.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=yes&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=130&mobile=true&header=false&lang=${this.state.language}`,
        "*"
      );
      window.ReactNativeWebView.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=yes&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=13&mobile=true&header=false&lang=${this.state.language}`,
        "*"
      );
    } else {
      document.getElementById("iframe").classList.remove("hide");
      this.setState({
        userInfo: `https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=yes&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=13&lang=${this.state.language}`,
      });
    }
  }

  handleDestinationChange(selectedOptions) {
    console.log("Destination change:", selectedOptions);
    this.setState(
      {
        selectedDestinations: selectedOptions || [],
      },
      () => {
        this.getHotelsList();
      }
    );
  }

  handleHotelCategoryChange(selectedOptions) {
    console.log("Hotel category change:", selectedOptions);
    this.setState(
      {
        selectedHotelCategories: selectedOptions || [],
      },
      () => {
        this.getHotelsList();
      }
    );
  }

  handleAmenitiesChange(selectedOptions) {
    console.log("Amenities change:", selectedOptions);
    this.setState(
      {
        selectedAmenities: selectedOptions || [],
      },
      () => {
        this.getHotelsList();
      }
    );
  }

  transformOptions(options) {
    return options.map((option) => ({ name: option }));
  }

  handleCheck(e) {
    if (this.state[e.target.id] === "") {
      this.setState(
        {
          [e.target.id]: 1,
        },
        () => {
          this.getHotelsList();
        }
      );
    } else {
      this.setState(
        {
          [e.target.id]: "",
        },
        () => {
          this.getHotelsList();
        }
      );
    }
  }

  closeIframe() {
    document.getElementById("iframe").classList.add("hide");
  }

  toggleFilter() {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  }

  render() {
    const {
      premiumHotelsList,
      freeHotelsList,
      zoom,
      center,
      userInfo,
      mobile,
      width,
      loading,
      filterOpen,
      logo,
      subcategories,
      language,
    } = this.state;

    return (
      <div className="directoryContainer">
        {!mobile && (
          <div className="header">
            <BackButton
              useHistory={false}
              text={i18n.translate("general.back")}
            />
            <div className="search">
              <FontAwesomeIcon
                icon={["fas", "search"]}
                className="searchIcon"
              />
              <input
                className="searchInput"
                placeholder={i18n.translate("directoryView.search")}
                type="text"
                ref={(input) => (this.search = input)}
                onChange={this.handleInputChange}
              />
            </div>
            <img src={logo} className="logo" alt="logo" />
          </div>
        )}
        {mobile && (
          <style>
            {
              "\
              .cookieConsent { display: none !important; } .directoryContainer { height: 100vh; } .results { top: 0 !important; } .listContainer { height: calc(100vh - 22rem) !important; margin-top: 0 !important; } @media screen and (min-width: 699px) { .listContainer { height: calc(100vh - 18rem) !important; } }"
            }
          </style>
        )}
        <div className="directoryView">
          <div className="leftSide">
            <div className="results">
              {i18n.translate("directoryView.amountOfResults")}
              {freeHotelsList.length + premiumHotelsList.length}
              <button
                onClick={filterOpen ? this.toggleFilter : this.toggleFilter}
                className="filter-btn"
              >
                {filterOpen
                  ? i18n.translate("general.close")
                  : i18n.translate("directoryView.filter")}
              </button>
            </div>
            <div className="leftGrid">
              <div className={`filterContainer ${filterOpen ? "active" : ""}`}>
                {/* Destination Filter */}
                <div className="filterSection">
                  <h4>Destination</h4>
                  <Select
                    options={this.state.subcategories.destination.map(
                      (dest) => ({
                        label: dest,
                        value: dest,
                      })
                    )}
                    value={this.state.selectedDestinations}
                    onChange={this.handleDestinationChange}
                    placeholder="Select destination..."
                    isMulti
                    isSearchable={false}
                    isClearable
                    closeMenuOnSelect={false}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "38px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: "#e3f2fd",
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        color: "#1976d2",
                      }),
                      multiValueRemove: (provided) => ({
                        ...provided,
                        color: "#1976d2",
                        ":hover": {
                          backgroundColor: "#1976d2",
                          color: "white",
                        },
                      }),
                    }}
                  />
                </div>

                {/* Hotel Category Filter */}
                <div className="filterSection">
                  <h4>Hotel Category</h4>
                  <Select
                    options={this.state.subcategories.hotelcategory.map(
                      (cat) => ({
                        label: cat,
                        value: cat,
                      })
                    )}
                    value={this.state.selectedHotelCategories}
                    onChange={this.handleHotelCategoryChange}
                    placeholder="Select hotel category..."
                    isMulti
                    isSearchable={false}
                    isClearable
                    closeMenuOnSelect={false}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "38px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: "#e3f2fd",
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        color: "#1976d2",
                      }),
                      multiValueRemove: (provided) => ({
                        ...provided,
                        color: "#1976d2",
                        ":hover": {
                          backgroundColor: "#1976d2",
                          color: "white",
                        },
                      }),
                    }}
                  />
                </div>

                {/* Amenities Filter */}
                <div className="filterSection">
                  <h4>Amenities</h4>
                  <Select
                    options={this.state.subcategories.amenities.map(
                      (amenity) => ({
                        label: amenity,
                        value: amenity,
                      })
                    )}
                    value={this.state.selectedAmenities}
                    onChange={this.handleAmenitiesChange}
                    placeholder="Select amenity..."
                    isMulti
                    isSearchable={false}
                    isClearable
                    closeMenuOnSelect={false}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "38px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: "#e3f2fd",
                      }),
                      multiValueLabel: (provided) => ({
                        ...provided,
                        color: "#1976d2",
                      }),
                      multiValueRemove: (provided) => ({
                        ...provided,
                        color: "#1976d2",
                        ":hover": {
                          backgroundColor: "#1976d2",
                          color: "white",
                        },
                      }),
                    }}
                  />
                </div>

                <div
                  className="resetFilters"
                  onClick={() => {
                    this.resetFilters();
                  }}
                >
                  {i18n.translate("directoryView.resetFilters")}
                </div>
                <div className="text-center">
                  <button
                    onClick={this.resetFilters}
                    className="filter-btn inverted"
                  >
                    {i18n.translate("directoryView.resetFilters")}
                  </button>
                  <button onClick={this.toggleFilter} className="show-results">
                    {i18n.translate("directoryView.showResults")}
                  </button>
                </div>
              </div>

              {mobile && (
                <div className="search">
                  <FontAwesomeIcon
                    icon={["fas", "search"]}
                    className="searchIcon"
                  />
                  <input
                    className="searchInput"
                    placeholder={i18n.translate("directoryView.search")}
                    type="text"
                    ref={(input) => (this.search = input)}
                    onChange={this.handleInputChange}
                  />
                </div>
              )}

              <SimpleBarReact
                className={`listContainer ${filterOpen ? "filterOpen" : ""}`}
              >
                <div className="premiumList">
                  {loading && (
                    <span className="loader">
                      <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
                    </span>
                  )}
                  {premiumHotelsList.length > 0 &&
                    premiumHotelsList.map((hotel) => (
                      <PremiumHotel
                        key={hotel.id}
                        id={hotel.id}
                        bgImage={hotel.headerImages[0]}
                        propertyName={hotel.propertyName}
                        flyToMarker={() => {
                          this.flyToMarker(
                            hotel.coords.latitude,
                            hotel.coords.longitude
                          );
                        }}
                        hotelInfo={() => {
                          this.premiumInfo(hotel.userInfoID);
                        }}
                      />
                    ))}
                </div>
                <div className="freeList">
                  {freeHotelsList.length === 0 && !loading && (
                    <div className="noResults">
                      {i18n.translate("directoryView.noResults")}
                    </div>
                  )}
                  {/* Filter duplicates, because items are created for each category and can't have multiple */}
                  {freeHotelsList.length > 0 &&
                    freeHotelsList.map((hotel, i) => (
                      <React.Fragment key={hotel.company_listing_id}>
                        <FreeHotel
                          id={hotel.company_listing_id}
                          bgImage={hotel.img_path + hotel.photo_file}
                          flyToMarker={() => {
                            this.flyToMarker(hotel.latitude, hotel.longitude);
                          }}
                          hotelInfo={() => {
                            this.freeInfo(hotel.listing_id);
                          }}
                          hotelName={hotel.company}
                          location={hotel.state}
                          item={hotel}
                        />
                      </React.Fragment>
                    ))}
                  {zoom > 8 && (
                    <div
                      className="resetMap"
                      onClick={() => {
                        this.resetMap();
                      }}
                    >
                      {i18n.translate("directoryView.resetMap")}
                    </div>
                  )}
                </div>
              </SimpleBarReact>
            </div>
          </div>
          {width > 700 && (
            <div className="rightSide">
              <LoadScript
                googleMapsApiKey="AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc"
                language={language}
              >
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={(map) => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(
                      this.map.getBounds(),
                      this.map.getZoom()
                    );
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer
                    minimumClusterSize={4}
                    gridSize={100}
                    options={clusterFree}
                  >
                    {(clusterer) =>
                      freeHotelsList.length > 0 &&
                      freeHotelsList.map((freeHotel) => (
                        <Marker
                          key={freeHotel.listing_id}
                          position={{
                            lat: Number(freeHotel.latitude),
                            lng: Number(freeHotel.longitude),
                          }}
                          icon={MarkerFree}
                          onClick={() => {
                            this.flyToMarker(
                              freeHotel.latitude,
                              freeHotel.longitude
                            );
                          }}
                          clusterer={clusterer}
                        />
                      ))
                    }
                  </MarkerClusterer>
                  <MarkerClusterer
                    minimumClusterSize={5}
                    options={clusterPremium}
                  >
                    {(clusterer) =>
                      premiumHotelsList.length > 0 &&
                      premiumHotelsList.map((premiumHotel) => (
                        <Marker
                          key={premiumHotel.id}
                          position={{
                            lat: premiumHotel.coords.latitude,
                            lng: premiumHotel.coords.longitude,
                          }}
                          icon={MarkerPremium}
                          onClick={() => {
                            this.flyToMarker(
                              premiumHotel.coords.latitude,
                              premiumHotel.coords.longitude
                            );
                          }}
                          clusterer={clusterer}
                        />
                      ))
                    }
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            </div>
          )}

          <div className="iframe hide" id="iframe">
            <div
              className="bgIframe"
              onClick={() => {
                this.closeIframe();
              }}
            />
            <div className="iframeHolder">
              <div
                className="closeIframe"
                href="#"
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className="closeText">
                  <FontAwesomeIcon icon={["fas", "chevron-left"]} />{" "}
                  {i18n.translate("general.back")}
                </span>
              </div>
              <div className="contentIframe">
                <iframe
                  width="100%"
                  height="100%"
                  id="iframeModal"
                  src={userInfo}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
